import * as React from "react";
import territory from "../../territory";
import territoryProductType from "../../territory-product-type";
import territoryMarket from "../../territory-market";
import Dropdown from "../Dropdown/Dropdown";


const TeamMemberTerritoryInfo = ({data, handleChangeInput, handleChangeDropdown, viewMode, deleted, territoryMasterData}) => {
    return (
        <div>
            <div className="Team-member-territory">            
                <Dropdown
                    className="Team-member-info_column_item"
                    data={data}
                    optionKey='code'
                    optionLabelKey='name'
                    options={territory}
                    value={data.TERRITORY}
                    valueKey="TERRITORY"
                    label="Territory"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                    dropdownType="multiple"
                    optionsType="territory"
                />
                {data.TERRITORY && (
                <div className="collapse-inputs">
                    <Dropdown
                        className="Team-member-info_column_item"
                        data={data}
                        options={territoryProductType}
                        value={data.TYPE}
                        valueKey="TYPE"
                        label="Product Type"
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                        dropdownType="multiple"
                        optionsType="productType"
                    />
                    </div>
                )}
                {data.TERRITORY && data.TYPE && (
                <div className="collapse-inputs">
                    <Dropdown
                        className="Team-member-info_column_item"
                        data={data}
                        options={territoryMarket}
                        value={data.MARKET}
                        valueKey="MARKET"
                        label="Market"
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                        dropdownType="multiple"
                        optionsType="territoryMarket"
                        optionLabelKey='name'
                        optionKey='code'
                    />
                </div>
                )}
            </div>
        </div>
    );
};

export default TeamMemberTerritoryInfo;
